import React from "react";
import Loader from "../../../components/Common/Loader";
import useReleaseStockByAssignment from "../Hooks/useReleaseStockByAssignment";
import { AssignmentType } from "../../../api/Inventory/Entities/InventoryEntities";
import { Tooltip } from "../../../components/Utils/Tooltips";
import { Check } from "../../../components/Icons/Icons";
import { useTranslation } from "react-i18next";
import { resolveOfferedKits } from "./inventoryFormRules";

export default function GroupedReleaseStockList({ handleSubmit, initValue: { itemId, releaseId, assignmentType = AssignmentType.General.Name, assignId = null, excludedKitNumbers = [] } }) {
    const { t } = useTranslation();
    const [stockList, isStockLoading, navigation] = useReleaseStockByAssignment({
        intentoryItemId: itemId,
        releaseId: releaseId,
        assignmentType: assignmentType,
        assignId: assignId,
        excludeExpired: true
    })

    const onHandleSubmit = (selectedStock) => {
        handleSubmit(selectedStock)
    }

    const offeredStock = resolveOfferedKits(stockList, excludedKitNumbers)

    return (<Loader isLoading={isStockLoading}>
        <div style={{ maxHeight: '20vh', overflowY: 'auto' }}>
            <table className="table table-hover table-condensed table-spaced table-spaced-small">
                <thead>
                    <tr>
                        <th>{t('inventory.commons.kitNumber')}</th>
                        <th>{t('Cantidad')}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {offeredStock.map((row, index) =>
                    (<tr key={index}>
                        <td>{row.assignment.kitNumber == null || row.assignment.kitNumber.trim() == ''
                            ? t('inventory.dispense.withOutKit')
                            : row.assignment.kitNumber}</td>
                        <td>{row.quantity}</td>
                        <td>
                            <div key={index}>
                                <button type="button" className="btn-table-actions" onClick={() => { onHandleSubmit(row) }}>
                                    <Tooltip tooltip={'Seleccionar Stock'} id={"tooltipedit-" + row.Id}>
                                        <span aria-hidden="true"><Check /></span>
                                    </Tooltip>
                                </button>
                            </div>
                        </td>
                    </tr>))}
                </tbody>
            </table>
        </div>
    </Loader>)
}